import _ from 'lodash'

class SearchResultsController {
  constructor(RecordQueryService) {
    this.RecordQueryService = RecordQueryService
  }

  get results() {
    return this.RecordQueryService.records
  }

  get running() {
    return this.RecordQueryService.queryRunning
  }
}

SearchResultsController.$inject = ['RecordQueryService']

export default SearchResultsController
